// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    fundV1PrivateGetAccountBalance (params?: {}): Promise<Dict>;
    spotV1PublicGetServerTime (params?: {}): Promise<Dict>;
    spotV1PublicGetCommonSymbols (params?: {}): Promise<Dict>;
    spotV1PublicGetMarketTrades (params?: {}): Promise<Dict>;
    spotV1PublicGetMarketDepth (params?: {}): Promise<Dict>;
    spotV1PublicGetMarketKline (params?: {}): Promise<Dict>;
    spotV1PublicGetTicker24hr (params?: {}): Promise<Dict>;
    spotV1PublicGetTickerPrice (params?: {}): Promise<Dict>;
    spotV1PublicGetTickerBookTicker (params?: {}): Promise<Dict>;
    spotV1PrivateGetTradeQuery (params?: {}): Promise<Dict>;
    spotV1PrivateGetTradeOpenOrders (params?: {}): Promise<Dict>;
    spotV1PrivateGetTradeHistoryOrders (params?: {}): Promise<Dict>;
    spotV1PrivateGetTradeMyTrades (params?: {}): Promise<Dict>;
    spotV1PrivateGetUserCommissionRate (params?: {}): Promise<Dict>;
    spotV1PrivateGetAccountBalance (params?: {}): Promise<Dict>;
    spotV1PrivateGetOcoOrderList (params?: {}): Promise<Dict>;
    spotV1PrivateGetOcoOpenOrderList (params?: {}): Promise<Dict>;
    spotV1PrivateGetOcoHistoryOrderList (params?: {}): Promise<Dict>;
    spotV1PrivatePostTradeOrder (params?: {}): Promise<Dict>;
    spotV1PrivatePostTradeCancel (params?: {}): Promise<Dict>;
    spotV1PrivatePostTradeBatchOrders (params?: {}): Promise<Dict>;
    spotV1PrivatePostTradeOrderCancelReplace (params?: {}): Promise<Dict>;
    spotV1PrivatePostTradeCancelOrders (params?: {}): Promise<Dict>;
    spotV1PrivatePostTradeCancelOpenOrders (params?: {}): Promise<Dict>;
    spotV1PrivatePostTradeCancelAllAfter (params?: {}): Promise<Dict>;
    spotV1PrivatePostOcoOrder (params?: {}): Promise<Dict>;
    spotV1PrivatePostOcoCancel (params?: {}): Promise<Dict>;
    spotV2PublicGetMarketDepth (params?: {}): Promise<Dict>;
    spotV2PublicGetMarketKline (params?: {}): Promise<Dict>;
    spotV2PublicGetTickerPrice (params?: {}): Promise<Dict>;
    spotV2PublicGetQuoteBookTicker (params?: {}): Promise<Dict>;
    spotV2PublicGetQuoteDepth (params?: {}): Promise<Dict>;
    spotV2PublicGetQuoteHistoricalKlines (params?: {}): Promise<Dict>;
    spotV2PublicGetQuoteHistoricalTrades (params?: {}): Promise<Dict>;
    spotV2PublicGetQuoteKlines (params?: {}): Promise<Dict>;
    spotV2PublicGetQuotePrice (params?: {}): Promise<Dict>;
    spotV2PublicGetQuoteTicker (params?: {}): Promise<Dict>;
    spotV2PublicGetQuoteTrades (params?: {}): Promise<Dict>;
    spotV3PrivateGetGetAssetTransfer (params?: {}): Promise<Dict>;
    spotV3PrivateGetAssetTransfer (params?: {}): Promise<Dict>;
    spotV3PrivateGetCapitalDepositHisrec (params?: {}): Promise<List>;
    spotV3PrivateGetCapitalWithdrawHistory (params?: {}): Promise<List>;
    spotV3PrivatePostPostAssetTransfer (params?: {}): Promise<Dict>;
    swapV1PublicGetTickerPrice (params?: {}): Promise<Dict>;
    swapV1PublicGetMarketHistoricalTrades (params?: {}): Promise<Dict>;
    swapV1PublicGetMarketMarkPriceKlines (params?: {}): Promise<Dict>;
    swapV1PublicGetTradeMultiAssetsRules (params?: {}): Promise<Dict>;
    swapV1PublicGetTradingRules (params?: {}): Promise<Dict>;
    swapV1PrivateGetPositionSideDual (params?: {}): Promise<Dict>;
    swapV1PrivateGetTradeBatchCancelReplace (params?: {}): Promise<Dict>;
    swapV1PrivateGetTradeFullOrder (params?: {}): Promise<Dict>;
    swapV1PrivateGetMaintMarginRatio (params?: {}): Promise<Dict>;
    swapV1PrivateGetTradePositionHistory (params?: {}): Promise<Dict>;
    swapV1PrivateGetPositionMarginHistory (params?: {}): Promise<Dict>;
    swapV1PrivateGetTwapOpenOrders (params?: {}): Promise<Dict>;
    swapV1PrivateGetTwapHistoryOrders (params?: {}): Promise<Dict>;
    swapV1PrivateGetTwapOrderDetail (params?: {}): Promise<Dict>;
    swapV1PrivateGetTradeAssetMode (params?: {}): Promise<Dict>;
    swapV1PrivateGetUserMarginAssets (params?: {}): Promise<Dict>;
    swapV1PrivatePostTradeAmend (params?: {}): Promise<Dict>;
    swapV1PrivatePostTradeCancelReplace (params?: {}): Promise<Dict>;
    swapV1PrivatePostPositionSideDual (params?: {}): Promise<Dict>;
    swapV1PrivatePostTradeBatchCancelReplace (params?: {}): Promise<Dict>;
    swapV1PrivatePostTradeClosePosition (params?: {}): Promise<Dict>;
    swapV1PrivatePostTradeGetVst (params?: {}): Promise<Dict>;
    swapV1PrivatePostTwapOrder (params?: {}): Promise<Dict>;
    swapV1PrivatePostTwapCancelOrder (params?: {}): Promise<Dict>;
    swapV1PrivatePostTradeAssetMode (params?: {}): Promise<Dict>;
    swapV1PrivatePostTradeReverse (params?: {}): Promise<Dict>;
    swapV1PrivatePostTradeAutoAddMargin (params?: {}): Promise<Dict>;
    swapV2PublicGetServerTime (params?: {}): Promise<Dict>;
    swapV2PublicGetQuoteContracts (params?: {}): Promise<Dict>;
    swapV2PublicGetQuotePrice (params?: {}): Promise<Dict>;
    swapV2PublicGetQuoteDepth (params?: {}): Promise<Dict>;
    swapV2PublicGetQuoteTrades (params?: {}): Promise<Dict>;
    swapV2PublicGetQuotePremiumIndex (params?: {}): Promise<Dict>;
    swapV2PublicGetQuoteFundingRate (params?: {}): Promise<Dict>;
    swapV2PublicGetQuoteKlines (params?: {}): Promise<Dict>;
    swapV2PublicGetQuoteOpenInterest (params?: {}): Promise<Dict>;
    swapV2PublicGetQuoteTicker (params?: {}): Promise<Dict>;
    swapV2PublicGetQuoteBookTicker (params?: {}): Promise<Dict>;
    swapV2PrivateGetUserBalance (params?: {}): Promise<Dict>;
    swapV2PrivateGetUserPositions (params?: {}): Promise<Dict>;
    swapV2PrivateGetUserIncome (params?: {}): Promise<Dict>;
    swapV2PrivateGetTradeOpenOrders (params?: {}): Promise<Dict>;
    swapV2PrivateGetTradeOpenOrder (params?: {}): Promise<Dict>;
    swapV2PrivateGetTradeOrder (params?: {}): Promise<Dict>;
    swapV2PrivateGetTradeMarginType (params?: {}): Promise<Dict>;
    swapV2PrivateGetTradeLeverage (params?: {}): Promise<Dict>;
    swapV2PrivateGetTradeForceOrders (params?: {}): Promise<Dict>;
    swapV2PrivateGetTradeAllOrders (params?: {}): Promise<Dict>;
    swapV2PrivateGetTradeAllFillOrders (params?: {}): Promise<Dict>;
    swapV2PrivateGetTradeFillHistory (params?: {}): Promise<Dict>;
    swapV2PrivateGetTradePositionHistory (params?: {}): Promise<Dict>;
    swapV2PrivateGetUserIncomeExport (params?: {}): Promise<Dict>;
    swapV2PrivateGetUserCommissionRate (params?: {}): Promise<Dict>;
    swapV2PrivateGetQuoteBookTicker (params?: {}): Promise<Dict>;
    swapV2PrivatePostTradeGetVst (params?: {}): Promise<Dict>;
    swapV2PrivatePostTradeOrder (params?: {}): Promise<Dict>;
    swapV2PrivatePostTradeBatchOrders (params?: {}): Promise<Dict>;
    swapV2PrivatePostTradeCloseAllPositions (params?: {}): Promise<Dict>;
    swapV2PrivatePostTradeCancelAllAfter (params?: {}): Promise<Dict>;
    swapV2PrivatePostTradeMarginType (params?: {}): Promise<Dict>;
    swapV2PrivatePostTradeLeverage (params?: {}): Promise<Dict>;
    swapV2PrivatePostTradePositionMargin (params?: {}): Promise<Dict>;
    swapV2PrivatePostTradeOrderTest (params?: {}): Promise<Dict>;
    swapV2PrivateDeleteTradeOrder (params?: {}): Promise<Dict>;
    swapV2PrivateDeleteTradeBatchOrders (params?: {}): Promise<Dict>;
    swapV2PrivateDeleteTradeAllOpenOrders (params?: {}): Promise<Dict>;
    swapV3PublicGetQuoteKlines (params?: {}): Promise<Dict>;
    swapV3PrivateGetUserBalance (params?: {}): Promise<Dict>;
    cswapV1PublicGetMarketContracts (params?: {}): Promise<Dict>;
    cswapV1PublicGetMarketPremiumIndex (params?: {}): Promise<Dict>;
    cswapV1PublicGetMarketOpenInterest (params?: {}): Promise<Dict>;
    cswapV1PublicGetMarketKlines (params?: {}): Promise<Dict>;
    cswapV1PublicGetMarketDepth (params?: {}): Promise<Dict>;
    cswapV1PublicGetMarketTicker (params?: {}): Promise<Dict>;
    cswapV1PrivateGetTradeLeverage (params?: {}): Promise<Dict>;
    cswapV1PrivateGetTradeForceOrders (params?: {}): Promise<Dict>;
    cswapV1PrivateGetTradeAllFillOrders (params?: {}): Promise<Dict>;
    cswapV1PrivateGetTradeOpenOrders (params?: {}): Promise<Dict>;
    cswapV1PrivateGetTradeOrderDetail (params?: {}): Promise<Dict>;
    cswapV1PrivateGetTradeOrderHistory (params?: {}): Promise<Dict>;
    cswapV1PrivateGetTradeMarginType (params?: {}): Promise<Dict>;
    cswapV1PrivateGetUserCommissionRate (params?: {}): Promise<Dict>;
    cswapV1PrivateGetUserPositions (params?: {}): Promise<Dict>;
    cswapV1PrivateGetUserBalance (params?: {}): Promise<Dict>;
    cswapV1PrivatePostTradeOrder (params?: {}): Promise<Dict>;
    cswapV1PrivatePostTradeLeverage (params?: {}): Promise<Dict>;
    cswapV1PrivatePostTradeAllOpenOrders (params?: {}): Promise<Dict>;
    cswapV1PrivatePostTradeCloseAllPositions (params?: {}): Promise<Dict>;
    cswapV1PrivatePostTradeMarginType (params?: {}): Promise<Dict>;
    cswapV1PrivatePostTradePositionMargin (params?: {}): Promise<Dict>;
    cswapV1PrivateDeleteTradeAllOpenOrders (params?: {}): Promise<Dict>;
    cswapV1PrivateDeleteTradeCancelOrder (params?: {}): Promise<Dict>;
    cswapV2PrivatePostTradeOrder (params?: {}): Promise<Dict>;
    contractV1PrivateGetAllPosition (params?: {}): Promise<Dict>;
    contractV1PrivateGetAllOrders (params?: {}): Promise<Dict>;
    contractV1PrivateGetBalance (params?: {}): Promise<Dict>;
    walletsV1PrivateGetCapitalConfigGetall (params?: {}): Promise<Dict>;
    walletsV1PrivateGetCapitalDepositAddress (params?: {}): Promise<Dict>;
    walletsV1PrivateGetCapitalInnerTransferRecords (params?: {}): Promise<Dict>;
    walletsV1PrivateGetCapitalSubAccountDepositAddress (params?: {}): Promise<Dict>;
    walletsV1PrivateGetCapitalDepositSubHisrec (params?: {}): Promise<Dict>;
    walletsV1PrivateGetCapitalSubAccountInnerTransferRecords (params?: {}): Promise<Dict>;
    walletsV1PrivateGetCapitalDepositRiskRecords (params?: {}): Promise<Dict>;
    walletsV1PrivatePostCapitalWithdrawApply (params?: {}): Promise<Dict>;
    walletsV1PrivatePostCapitalInnerTransferApply (params?: {}): Promise<Dict>;
    walletsV1PrivatePostCapitalSubAccountInnerTransferApply (params?: {}): Promise<Dict>;
    walletsV1PrivatePostCapitalDepositCreateSubAddress (params?: {}): Promise<Dict>;
    subAccountV1PrivateGetList (params?: {}): Promise<Dict>;
    subAccountV1PrivateGetAssets (params?: {}): Promise<Dict>;
    subAccountV1PrivateGetAllAccountBalance (params?: {}): Promise<Dict>;
    subAccountV1PrivatePostCreate (params?: {}): Promise<Dict>;
    subAccountV1PrivatePostApiKeyCreate (params?: {}): Promise<Dict>;
    subAccountV1PrivatePostApiKeyEdit (params?: {}): Promise<Dict>;
    subAccountV1PrivatePostApiKeyDel (params?: {}): Promise<Dict>;
    subAccountV1PrivatePostUpdateStatus (params?: {}): Promise<Dict>;
    accountV1PrivateGetUid (params?: {}): Promise<Dict>;
    accountV1PrivateGetApiKeyQuery (params?: {}): Promise<Dict>;
    accountV1PrivateGetAccountApiPermissions (params?: {}): Promise<Dict>;
    accountV1PrivateGetAccountApiRestrictions (params?: {}): Promise<Dict>;
    accountV1PrivateGetAllAccountBalance (params?: {}): Promise<Dict>;
    accountV1PrivatePostInnerTransferAuthorizeSubAccount (params?: {}): Promise<Dict>;
    accountTransferV1PrivateGetSubAccountAssetTransferHistory (params?: {}): Promise<Dict>;
    accountTransferV1PrivatePostSubAccountTransferAssetSupportCoins (params?: {}): Promise<Dict>;
    accountTransferV1PrivatePostSubAccountTransferAsset (params?: {}): Promise<Dict>;
    userAuthPrivatePostUserDataStream (params?: {}): Promise<Dict>;
    userAuthPrivatePutUserDataStream (params?: {}): Promise<Dict>;
    userAuthPrivateDeleteUserDataStream (params?: {}): Promise<Dict>;
    copyTradingV1PrivateGetSwapTraceCurrentTrack (params?: {}): Promise<Dict>;
    copyTradingV1PrivateGetPFuturesTraderDetail (params?: {}): Promise<Dict>;
    copyTradingV1PrivateGetPFuturesProfitHistorySummarys (params?: {}): Promise<Dict>;
    copyTradingV1PrivateGetPFuturesProfitDetail (params?: {}): Promise<Dict>;
    copyTradingV1PrivateGetPFuturesTradingPairs (params?: {}): Promise<Dict>;
    copyTradingV1PrivateGetSpotTraderDetail (params?: {}): Promise<Dict>;
    copyTradingV1PrivateGetSpotProfitHistorySummarys (params?: {}): Promise<Dict>;
    copyTradingV1PrivateGetSpotProfitDetail (params?: {}): Promise<Dict>;
    copyTradingV1PrivateGetSpotHistoryOrder (params?: {}): Promise<Dict>;
    copyTradingV1PrivatePostSwapTraceCloseTrackOrder (params?: {}): Promise<Dict>;
    copyTradingV1PrivatePostSwapTraceSetTPSL (params?: {}): Promise<Dict>;
    copyTradingV1PrivatePostPFuturesSetCommission (params?: {}): Promise<Dict>;
    copyTradingV1PrivatePostSpotTraderSellOrder (params?: {}): Promise<Dict>;
    apiV3PrivateGetAssetTransfer (params?: {}): Promise<Dict>;
    apiV3PrivateGetAssetTransferRecord (params?: {}): Promise<Dict>;
    apiV3PrivateGetCapitalDepositHisrec (params?: {}): Promise<Dict>;
    apiV3PrivateGetCapitalWithdrawHistory (params?: {}): Promise<Dict>;
    apiV3PrivatePostPostAssetTransfer (params?: {}): Promise<Dict>;
    apiAssetV1PrivatePostTransfer (params?: {}): Promise<Dict>;
    apiAssetV1PublicGetTransferSupportCoins (params?: {}): Promise<Dict>;
    agentV1PrivateGetAccountInviteAccountList (params?: {}): Promise<Dict>;
    agentV1PrivateGetRewardCommissionDataList (params?: {}): Promise<Dict>;
    agentV1PrivateGetAccountInviteRelationCheck (params?: {}): Promise<Dict>;
    agentV1PrivateGetAssetDepositDetailList (params?: {}): Promise<Dict>;
    agentV1PrivateGetRewardThirdCommissionDataList (params?: {}): Promise<Dict>;
    agentV1PrivateGetAssetPartnerData (params?: {}): Promise<Dict>;
    agentV1PrivateGetCommissionDataListReferralCode (params?: {}): Promise<Dict>;
    agentV1PrivateGetAccountSuperiorCheck (params?: {}): Promise<Dict>;
    wealthV1PrivateGetProductDualCurrencyPreOrder (params?: {}): Promise<Dict>;
    wealthV1PrivateGetProductDualCurrencyPosition (params?: {}): Promise<Dict>;
    wealthV1PrivateGetProductDualCurrencyOrderRecords (params?: {}): Promise<Dict>;
    wealthV1PrivatePostProductDualCurrencyInvestAssetList (params?: {}): Promise<Dict>;
    wealthV1PrivatePostProductDualCurrencyOrder (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
